import React, { memo } from "react";
import KPIGroup from "./KPIGroup";

const KPIRow = ({ rowData }) => {
  return rowData.map((eachGroup, index) => {
    return (
      <KPIGroup
        key={eachGroup.kpiGroup}
        kpiGroupData={eachGroup}
        index={index}
      />
    );
  });
};

export default memo(KPIRow);
